/* eslint-disable no-mixed-operators */
import React, { useContext, useState } from "react";
import CustomDatePicker from "../../../../components/CustomDatePicker/CustomDatepicker.js";
import Button from "../../../../components/Button/Button.js";
import BoxFooter from "../../../../components/BoxFooter/BoxFooter.js";
import NumberInput from "../../../../components/NumberInput/NumberInput.js";
import FieldsetSelect from "../../../../components/FieldsetSelect/FieldsetSelect.js";
import {
  createEpisodesMenuOptions,
  returnAttachmentTypesListByContentType,
  returnNextValidEpisodeNumber,
} from "../../utils.js";
import { ADDENDUM_TYPE_ID } from "../../../../components/UploadedFile/UploadInputs/Addendum/addendum.utils";
import AppContext from "../../../../context/appContext.js";
import SheetContext from "../../../../context/sheetContext.js";

const FormAndFields = (props) => {
  const {
    action,
    handleSubmit,
    handleChangeByInputName,
    values,
    handleStartDates,
    handleMaxDates,
    schedulerType,
    planningData,
    handleValidate,
    customFooter = false,
    isMaterial,
    list,
    maxChaptersByBlock,
  } = props;

  const [showHiddenFields, setShowHiddenFields] = useState(false);

  const appContext = useContext(AppContext);
  const projectSheetContext = useContext(SheetContext);

  const contentType = projectSheetContext.list.result.projectType.toLowerCase();
  const planning = values.planning || {};

  const ATTACHMENT_TYPES_LIST = [...appContext.currentOriginFileType.result];

  const attachmentTypesList = returnAttachmentTypesListByContentType(
    contentType,
    ATTACHMENT_TYPES_LIST,
    schedulerType
  );

  const createPlanningAttachmentTypesList = attachmentTypesList.filter(
    (item) => Number(item?.id) !== ADDENDUM_TYPE_ID
  );

  const nextEpisodeAvailable = isMaterial
    ? returnNextValidEpisodeNumber({
        versionsList: list[planningData.dataKey],
      })
    : 0;

  const episodesMenuOptions = createEpisodesMenuOptions(nextEpisodeAvailable);

  const fields = planningData?.dateFields[action];

  const haveHiddenFields = fields?.filter(
    (field) => field.startHiddenOnCreate
  )?.length;

  const parseDate = (date) => {
    if (!date || date === "") return null;

    if (date instanceof Date) return date;

    const parsed = new Date(date);

    return isNaN(parsed.getTime()) ? null : parsed;
  };

  return (
    <form id="FormAndFields">
      {action === "create" && (
        <div className="customDatesContainer">
          <FieldsetSelect
            name="typeId"
            label="Tipo de Material"
            placeholder="Selecione um material"
            handleChange={(e) =>
              handleChangeByInputName(e.target.value, "typeId")
            }
            selected={values.typeId || ""}
            data={createPlanningAttachmentTypesList}
          />

          {schedulerType === "Materiais" && values.typeId === "1211" && (
            <div className="episodeNumberSelector">
              <FieldsetSelect
                name="attachmentTypeId"
                label="Nº Episódio"
                handleChange={(e) =>
                  handleChangeByInputName(e.target.value, "chapterNumber")
                }
                selected={values?.chapterNumber || "1"}
                data={episodesMenuOptions}
                placeholder={""}
              />
            </div>
          )}

          {(schedulerType === "Materiais" ||
            (schedulerType === "Capítulos/Sinopse" &&
              Number(values.typeId) !== 1211)) && (
            <NumberInput
              label="Número da Versão"
              getVersion={(value) => handleChangeByInputName(value, "version")}
              maxNumber={values.version}
              minNumber={values.version}
              darkBackgroundColor={false}
              number={values?.version}
            />
          )}

          {schedulerType === "Capítulos/Sinopse" &&
            values.typeId === "1211" &&
            action === "create" && (
              <div className="chaptersNumberContainer">
                <NumberInput
                  label="Nº de Capítulos"
                  getVersion={(value) =>
                    handleChangeByInputName(value, "numberChaptersBlock")
                  }
                  maxNumber={maxChaptersByBlock}
                  darkBackgroundColor={false}
                  number={
                    !!values.numberChaptersBlock
                      ? values.numberChaptersBlock
                      : 6
                  }
                />
              </div>
            )}
        </div>
      )}

      <div className="customDatesContainer">
        {(action === "create" ||
          action === "edit" ||
          action === "editAttachment") && (
          <>
            {fields
              ?.filter((field) => !field.startHiddenOnCreate)
              ?.map((item, index) => {
                return (
                  <div className="customDate" key={index}>
                    <CustomDatePicker
                      label={item.label}
                      date={parseDate(planning[item.key])}
                      isScroll={true}
                      startDate={handleStartDates[action][item.key]}
                      maxDate={handleMaxDates[action][item.key]}
                      handleChangeDate={(date) =>
                        handleChangeByInputName(date, item.key)
                      }
                      disabled={!!item.isDisabled}
                      placement="top-end"
                    />
                  </div>
                );
              })}

            {!!haveHiddenFields &&
              showHiddenFields &&
              fields
                .filter((field) => field.startHiddenOnCreate)
                .map((item, index) => {
                  return (
                    <div className="customDate" key={index}>
                      <CustomDatePicker
                        label={item.label}
                        date={parseDate(planning[item.key])}
                        isScroll={true}
                        startDate={handleStartDates[action][item.key]}
                        maxDate={handleMaxDates[action][item.key]}
                        handleChangeDate={(date) =>
                          handleChangeByInputName(date, item.key)
                        }
                        disabled={!!item.isDisabled}
                        placement="top-end"
                      />
                    </div>
                  );
                })}
          </>
        )}

        {(action === "create" ||
          action === "edit" ||
          action === "editAttachment") &&
          !showHiddenFields &&
          !!haveHiddenFields && (
            <div
              onClick={() => setShowHiddenFields(true)}
              className="showMoreFields"
            >
              Mais...
            </div>
          )}
      </div>

      <div className="formAndFieldsFooter">
        <BoxFooter customFooter={customFooter} classBox="customBox">
          {action === "create" && (
            <div className="saveAndCreateNew">
              <Button
                text={`Salvar + Criar`}
                toValidate={true}
                isValidForm={
                  typeof handleValidate === "function" ? handleValidate() : true
                }
                classButton="buttonGreen large"
                clickEvent={(event) => handleSubmit(event, false)}
              />
            </div>
          )}

          <Button
            text={`Salvar ${action === "editAttachment" ? "Anexo" : ""}`}
            toValidate={true}
            isValidForm={
              typeof handleValidate === "function" ? handleValidate() : true
            }
            classButton="buttonGreen large"
            clickEvent={handleSubmit}
          />
        </BoxFooter>
      </div>
    </form>
  );
};

export default FormAndFields;
